import { NgModule, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';

import { VentasRoutingModule } from './ventas-routing.module';
import { ClienteAddComponent } from './cliente-add/cliente-add.component';
import { ClienteEditComponent } from './cliente-edit/cliente-edit.component';
import { ClienteListComponent } from './cliente-list/cliente-list.component';
import { VentaListComponent } from './venta-list/venta-list.component';
import { VentaAddComponent } from './venta-add/venta-add.component';
import { CajaListComponent } from './caja-list/caja-list.component';
import { CajaEditComponent } from './caja-edit/caja-edit.component';
import { CajaAddComponent } from './caja-add/caja-add.component';
import { CajeroAsignarAddComponent } from './cajero-asignar-add/cajero-asignar-add.component';
import { CajeroAsignarListComponent } from './cajero-asignar-list/cajero-asignar-list.component';
import { ComprobanteAddComponent } from './comprobante-add/comprobante-add.component';
import { ComprobanteEditComponent } from './comprobante-edit/comprobante-edit.component';
import { ComprobanteListComponent } from './comprobante-list/comprobante-list.component';
import { RetencionesListComponent } from './retenciones-list/retenciones-list.component';
import { RetencionesAddComponent } from './retenciones-add/retenciones-add.component';
import { ProformaListComponent } from './proforma-list/proforma-list.component';
import { ProformaAddComponent } from './proforma-add/proforma-add.component';
import { GuiaremisionListComponent } from './guiaremision-list/guiaremision-list.component';
import { GuiaremisionAddComponent } from './guiaremision-add/guiaremision-add.component';
import { NotaCreditoListComponent } from './nota-credito-list/nota-credito-list.component';
import { NotaCreditoAddComponent } from './nota-credito-add/nota-credito-add.component';
import { NotaDebitoListComponent } from './nota-debito-list/nota-debito-list.component';
import { NotaDebitoAddComponent } from './nota-debito-add/nota-debito-add.component';
import { PreciosListComponent } from './precios-list/precios-list.component';
import { PreciosEditComponent } from './precios-edit/precios-edit.component';
import { PuntoVentaAddComponent } from './punto-venta-add/punto-venta-add.component';
import { PuntoVentaListComponent } from './punto-venta-list/punto-venta-list.component';
import { PuntoVentaTactilAddComponent } from './punto-venta-tactil-add/punto-venta-tactil-add.component';
import { PlanAcumulativoListComponent } from './plan-acumulativo-list/plan-acumulativo-list.component';
import { PlanAcumulativoAddComponent } from './plan-acumulativo-add/plan-acumulativo-add.component';
import { LoadingModule } from 'ngx-loading';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { PipesModule } from '../../pipes/pipes.module';
import { NguiDatetimePickerModule } from '@ngui/datetime-picker';
import { RlTagInputModule } from 'angular2-tag-input';
import { ControlsModule } from '../../controls/controls.module';
import { TabsModule, ButtonsModule, BsDropdownModule } from 'ngx-bootstrap';
import { ModalsModule } from '../modals/modals.module';
import { TransportistaAddComponent } from './transportista-add/transportista-add.component';
import { TransportistaEditComponent } from './transportista-edit/transportista-edit.component';
import { TransportistaListComponent } from './transportista-list/transportista-list.component';
import { PlanAcumulativoEditComponent } from './plan-acumulativo-edit/plan-acumulativo-edit.component';
import { CustomFormModule } from '../../forms/custom-form.module';
import { TextMaskModule } from 'angular2-text-mask';

@NgModule({
  imports: [
    CommonModule,
    VentasRoutingModule,
    LoadingModule.forRoot({
      backdropBorderRadius: '5px',
      fullScreenBackdrop: true
    }),
    ReactiveFormsModule,
    FormsModule,
    PipesModule,
    NguiDatetimePickerModule,
    RlTagInputModule,
    ControlsModule,
    TabsModule,
    ButtonsModule,
    ModalsModule,
    BsDropdownModule,
    CustomFormModule,
    TextMaskModule
  ],
  declarations: [
    ClienteAddComponent,
    ClienteEditComponent,
    ClienteListComponent,
    VentaListComponent,
    VentaAddComponent,
    CajaListComponent,
    CajaEditComponent,
    CajaAddComponent,
    CajeroAsignarAddComponent,
    CajeroAsignarListComponent,
    ComprobanteAddComponent,
    ComprobanteEditComponent,
    ComprobanteListComponent,
    RetencionesListComponent,
    RetencionesAddComponent,
    ProformaListComponent,
    ProformaAddComponent,
    GuiaremisionListComponent,
    GuiaremisionAddComponent,
    NotaCreditoListComponent,
    NotaCreditoAddComponent,
    NotaDebitoListComponent,
    NotaDebitoAddComponent,
    PreciosListComponent,
    PreciosEditComponent,
    PuntoVentaAddComponent,
    PuntoVentaListComponent,
    PuntoVentaTactilAddComponent,
    PlanAcumulativoListComponent,
    PlanAcumulativoAddComponent,
    PlanAcumulativoEditComponent,
    TransportistaAddComponent,
    TransportistaEditComponent,
    TransportistaListComponent,
  ],
  exports: [
    GuiaremisionAddComponent,
    TransportistaAddComponent
  ],
  schemas: [ CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA ],
})
export class VentasModule { }



// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/components/ventas/ventas.module.ts